import { useTranslations } from 'next-intl';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { AssignmentStatus } from '../types';

const STATUS_STYLES: Record<AssignmentStatus, string> = {
  pending:
    'border-amber-500/30 bg-amber-500/10 text-amber-600 dark:text-amber-400',
  confirmed: 'border-sky-500/30 bg-sky-500/10 text-sky-600 dark:text-sky-400',
  in_progress:
    'border-blue-500/30 bg-blue-500/10 text-blue-600 dark:text-blue-400',
  completed:
    'border-emerald-500/30 bg-emerald-500/10 text-emerald-600 dark:text-emerald-400'
};

interface AssignmentStatusBadgeProps {
  status: AssignmentStatus;
  className?: string;
}

export function AssignmentStatusBadge({
  status,
  className
}: AssignmentStatusBadgeProps) {
  const t = useTranslations('handoverScanning');
  return (
    <Badge
      variant='outline'
      className={cn(
        'shrink-0 text-xs uppercase',
        STATUS_STYLES[status],
        className
      )}
    >
      {t(`status_${status}`)}
    </Badge>
  );
}
